import React from "react";
import { Grid, Box, makeStyles } from "@material-ui/core";

import ImageViewer from "./ImageViewer";
import ProductInformationBloc from "./ProductInformationBloc";
import ProductInformationHeader from "./ProductInformationHeader";

import GTMPushProductTag from "../../components/gtmTag/pushProduct";

function ProductDetailCard({ product, category, offline }) {
  const classes = useStyle();
  const images = product.pictures.map((picture) => picture.url);

  return (
    <div className={classes.container}>
      <GTMPushProductTag product={product} />
      <Grid container className={classes.grid}>
        <Grid item xs={12} md={6}>
          <Box position="sticky" top="150px" zIndex={2}>
            <ImageViewer pictureNew={product.picture_new} images={images} product={product} />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box px={2}>
            <ProductInformationHeader product={product} offline={offline} />
            <ProductInformationBloc product={product} category={category} offline={offline} />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(4),
    },
  },
  grid: {
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      "& > :first-child": {
        paddingRight: theme.spacing(8),
      },
    },
  },
}));

export default ProductDetailCard;
